import PropTypes from "prop-types";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Image, Title } from "@/ui";
import classes from "./styles.module.scss";
import { QuickJobSearch } from "@/components";

const HERO_IMAGE =
  "https://cdn.sourceflow.co.uk/0by7ua8qy44c7pigecrv46d3j2fe";

export const Hero = ({ className, title, titleColor }) => {
  return (
    <div className={clsx(className, classes.hero)}>
      <figure className={classes.hero__img}>
        <Image
          img={HERO_IMAGE}
          size="1920x"
          alt="Hero image"
          className="w-100"
          style={{ maxHeight: "600px", objectFit: "cover" }}
        />
      </figure>
      <div className={classes.hero__content}>
        <Container>
          <Row>
            <Col xs={12} md={8}>
              <Title title={title} tag="h1" className={clsx(titleColor, "bg-primary p-4 pe-5 m-0 me-6 rounded")} />
              <QuickJobSearch />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Hero;
